module.exports = __webpack_public_path__ + "img/desk.c3527dd2.png";